import { render, staticRenderFns } from "./SetPlayer.vue?vue&type=template&id=78f52f31&scoped=true&"
import script from "./SetPlayer.vue?vue&type=script&lang=js&"
export * from "./SetPlayer.vue?vue&type=script&lang=js&"
import style0 from "./SetPlayer.vue?vue&type=style&index=0&id=78f52f31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f52f31",
  null
  
)

export default component.exports